import { Provider } from "@redotech/redo-order-common/provider";
import { ShopifyGraphQLProductSchema } from "@redotech/redo-product-common/product";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getProduct = {
  name: "getProduct" as const,
  input: z.object({ productId: z.string(), provider: createEnum(Provider) }),
  output: z.object({ product: ShopifyGraphQLProductSchema.nullable() }),
};
